import { render } from "./InfectionModal.vue?vue&type=template&id=8e7e37ea&scoped=true"
import script from "./InfectionModal.vue?vue&type=script&lang=js"
export * from "./InfectionModal.vue?vue&type=script&lang=js"

import "./InfectionModal.vue?vue&type=style&index=0&id=8e7e37ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7e37ea"]])

export default __exports__